import WordpressContent from 'components/Content/WordpressContent';
import Layout from 'components/Layout/Layout';
import OrganisationHome from 'components/OrganisationHome/OrganisationHome';
import PageMeta from 'components/PageMeta';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { CommonPageProps } from 'types/CommonPageProps';

type PageProps = CommonPageProps<{
    content: string;
    elementorCss: string | null;
    elementorScripts: string[];
    elementorConfig: string | null;
}>;

export default function IndexPage(props: PageProps) {
    const { content, elementorCss, elementorScripts, elementorConfig } = props;
    const { t } = useServerTranslation();

    return (
        <Layout containerProps={{ sx: { maxWidth: '1024px' } }}>
            <PageMeta
                title={t('seo.title.home')}
                description={t('seo.description.home')}
            />
            <OrganisationHome />
            <WordpressContent content={content} elementorCss={elementorCss} elementorScripts={elementorScripts} elementorConfig={elementorConfig} />
        </Layout>
    );
}
